<template>
  <div class="d-flex mb-3 conciliacao-filtros">
    <select v-model="local.contaId" class="form-select filtro-conta">
      <option value="">Conta financeira: Todas</option>
      <option v-for="conta in contas" :key="conta.id" :value="String(conta.id)">
        {{ conta.apelido }} - {{ conta.agencia }} - {{ conta.numero_conta }}
      </option>
    </select>

    <input
      v-model="local.competencia"
      type="month"
      class="form-control filtro-competencia"
      title="Competência"
    />

    <select
      v-model="local.status"
      class="form-select filtro-status"
      :disabled="!podeFiltrarStatus"
    >
      <option value="">Status: Todos</option>
      <option value="PENDENTE">Pendente de revisão</option>
      <option value="CONCILIADO_AUTOMATICO">Conciliado automático</option>
      <option value="CONCILIADO_MANUAL">Conciliado manual</option>
      <option value="SEM_LANCAMENTO_SISTEMA">Sem lançamento no sistema</option>
    </select>

    <select
      v-model="local.tipoMovimentoBanco"
      class="form-select filtro-tipo-movimento"
      :disabled="!podeFiltrarStatus"
    >
      <option value="">Tipo: Todos</option>
      <option value="CREDIT">Crédito</option>
      <option value="DEBIT">Débito</option>
    </select>    

    <input
      v-model="local.operadoraNome"
      type="text"
      class="form-control filtro-operadora"
      placeholder="Operadora"
      :disabled="!podeFiltrarStatus"
      @keyup.enter="emitirAplicar"
      @blur="onBlurOperadora"
    />

    <button
      type="button"
      class="btn btn-secondary d-flex align-items-center justify-content-center"
      @click="limpar"
    >
      <i class="bi bi-funnel" title="Limpar filtros"></i>
    </button>
  </div>
</template>

<script setup>
import { reactive, watch, computed } from 'vue'

const props = defineProps({
  filtros: {
    type: Object,
    required: true
  },
  contas: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['aplicar'])

const local = reactive({
  contaId: props.filtros.contaId || '',
  competencia: props.filtros.competencia || '',
  status: props.filtros.status || '',
  tipoMovimentoBanco: props.filtros.tipoMovimentoBanco || '',
  operadoraNome: props.filtros.operadoraNome || ''
})

const podeFiltrarStatus = computed(() =>
  !!local.contaId && !!local.competencia
)

watch(
  () => props.filtros,
  (v) => {
    local.contaId = v.contaId || ''
    local.competencia = v.competencia || ''
    local.status = v.status || ''
    local.tipoMovimentoBanco = v.tipoMovimentoBanco || ''
    local.operadoraNome = v.operadoraNome || ''
  },
  { deep: true }
)

watch(
  () => local.tipoMovimentoBanco,
  (novo, antigo) => {
    if (novo === antigo) return
    if (!podeFiltrarStatus.value) return

    emit('aplicar', { ...local })
  }
)

watch(
  () => [local.contaId, local.competencia],
  ([contaId, competencia], [oldContaId, oldCompetencia]) => {
    const mudou = contaId !== oldContaId || competencia !== oldCompetencia
    if (!mudou) return

    if (contaId && competencia) {
      emit('aplicar', { ...local })
    }
  }
)

watch(
  () => local.status,
  (novo, antigo) => {
    if (novo === antigo) return
    if (!podeFiltrarStatus.value) return

    emit('aplicar', { ...local })
  }
)

function emitirAplicar() {
  if (!podeFiltrarStatus.value) return
  emit('aplicar', { ...local })
}

function onBlurOperadora() {
  if (!podeFiltrarStatus.value) return
  emit('aplicar', { ...local })
}

function limpar() {
  emit('aplicar', {
    contaId: '',
    competencia: '',
    status: '',
    tipoMovimentoBanco: '',
    operadoraNome: ''
  })
}
</script>

<style scoped>
.conciliacao-filtros {
  gap: 10px;
  flex-wrap: wrap;
}

.filtro-conta {
  min-width: 260px;
  flex: 1.4 1 260px;
}

.filtro-competencia {
  min-width: 140px;
  flex: 0 1 140px;
}

.filtro-status {
  min-width: 190px;
  flex: 0.9 1 190px;
}

.filtro-tipo-movimento {
  min-width: 150px;
  flex: 0.7 1 150px;
}

.filtro-operadora {
  min-width: 170px;
  flex: 0.8 1 170px;
}

@media (max-width: 768px) {
  .conciliacao-filtros > * {
    width: 100%;
  }
}
</style>